export default {
    courseSectionId: 622453,
    studentId: 3047711,
    firstName: 'Bennie',
    lastName: 'Factor',
    topicCount: 147,
    noviceOrBelowTopicCount: 131,
    metrics: [
        {
            assignmentId: 4785643,
            assignmentName: 'Week 4 Quiz- In Class ',
            assignmentType: 'QUIZ_BY_QUESTION',
            gradeType: 'SCORED',
            status: 'COMPLETED',
            dueDate: '2024-07-19T03:59:00Z',
            pastDue: false,
            gradePoints: 29,
            score: '1.0',
            classAvgScore: 0.9870689655172376,
            timeSpent: 'PT13M18S',
            classAvgTimeSpent: 'PT16M29.5S',
            totalQuestionsAnswered: 29
        },
        {
            assignmentId: 4597508,
            assignmentName: 'Reduction of Risk Potential EAQ ',
            assignmentType: 'MASTERY',
            gradeType: 'PASS_FAIL',
            status: 'COMPLETED',
            dueDate: '2024-07-28T03:59:00Z',
            pastDue: false,
            gradePoints: 1,
            score: '1.0',
            classAvgScore: 0.0275,
            timeSpent: 'PT9H57M18S',
            classAvgTimeSpent: 'PT3H8M11.8125S',
            totalQuestionsAnswered: 182
        },
        {
            assignmentId: 4597509,
            assignmentName: 'Antidysrhythmic Drugs EAQ ',
            assignmentType: 'STANDARD',
            gradeType: 'PASS_FAIL',
            status: 'COMPLETED',
            dueDate: '2024-07-28T03:59:00Z',
            pastDue: false,
            gradePoints: 5,
            score: '1.0',
            classAvgScore: 1,
            timeSpent: 'PT1M44S',
            classAvgTimeSpent: 'PT1M50.125S',
            totalQuestionsAnswered: 5
        },
        {
            assignmentId: 4597505,
            assignmentName: 'Respiratory Drugs Pharm EAQ ',
            assignmentType: 'STANDARD',
            gradeType: 'PASS_FAIL',
            status: 'COMPLETED',
            dueDate: '2024-07-21T03:59:00Z',
            pastDue: false,
            gradePoints: 5,
            score: '1.0',
            classAvgScore: 0.011875,
            timeSpent: 'PT10M6S',
            classAvgTimeSpent: 'PT3M30.8125S',
            totalQuestionsAnswered: 5
        },
        {
            assignmentId: 4597518,
            assignmentName: 'Health Promotion & Maintenance EAQ ',
            assignmentType: 'MASTERY',
            gradeType: 'PASS_FAIL',
            status: 'COMPLETED',
            dueDate: '2024-08-04T03:59:00Z',
            pastDue: false,
            gradePoints: 1,
            score: '1.0',
            classAvgScore: 0.025,
            timeSpent: 'PT3H1S',
            classAvgTimeSpent: 'PT3H7M32S',
            totalQuestionsAnswered: 161
        },
        {
            assignmentId: 4597481,
            assignmentName: 'Management of Care EAQ ',
            assignmentType: 'MASTERY',
            gradeType: 'PASS_FAIL',
            status: 'COMPLETED',
            dueDate: '2024-06-30T03:59:00Z',
            pastDue: false,
            gradePoints: 1,
            score: '1.0',
            classAvgScore: 0.02125,
            timeSpent: 'PT7H24M59S',
            classAvgTimeSpent: 'PT4H32M15.4375S',
            totalQuestionsAnswered: 328
        },
        {
            assignmentId: 4597495,
            assignmentName: 'Antiviral Drugs EAQ ',
            assignmentType: 'STANDARD',
            gradeType: 'PASS_FAIL',
            status: 'COMPLETED',
            dueDate: '2024-07-07T03:59:00Z',
            pastDue: false,
            gradePoints: 5,
            score: '1.0',
            classAvgScore: 0.010625,
            timeSpent: 'PT1M57S',
            classAvgTimeSpent: 'PT2M19.4375S',
            totalQuestionsAnswered: 5
        },
        {
            assignmentId: 4597491,
            assignmentName: 'Safety & Infection Control EAQ (Intermediate)',
            assignmentType: 'MASTERY',
            gradeType: 'PASS_FAIL',
            status: 'COMPLETED',
            dueDate: '2024-07-07T03:59:00Z',
            pastDue: false,
            gradePoints: 1,
            score: '1.0',
            classAvgScore: 0.015,
            timeSpent: 'PT17M13S',
            classAvgTimeSpent: 'PT27M10.875S',
            totalQuestionsAnswered: 6
        },
        {
            assignmentId: 4597520,
            assignmentName: 'Antibiotic Drugs EAQ ',
            assignmentType: 'STANDARD',
            gradeType: 'PASS_FAIL',
            status: 'COMPLETED',
            dueDate: '2024-08-04T03:59:00Z',
            pastDue: false,
            gradePoints: 5,
            score: '1.0',
            classAvgScore: 1,
            timeSpent: 'PT2M10S',
            classAvgTimeSpent: 'PT2M45.1875S',
            totalQuestionsAnswered: 5
        },
        {
            assignmentId: 4597488,
            assignmentName: 'Analgesic Therapy ',
            assignmentType: 'QUIZ_BY_QUESTION',
            gradeType: 'PASS_FAIL',
            status: 'COMPLETED',
            dueDate: '2024-06-30T03:59:00Z',
            pastDue: false,
            gradePoints: 20,
            score: '1.0',
            classAvgScore: 1,
            timeSpent: 'PT36M34S',
            classAvgTimeSpent: 'PT15M11.25S',
            totalQuestionsAnswered: 20
        },
        {
            assignmentId: 4597521,
            assignmentName: 'Critical Care Practice HESI',
            assignmentType: 'AUTHESS',
            gradeType: 'PASS_FAIL',
            status: 'COMPLETED',
            dueDate: '2024-08-04T03:59:00Z',
            pastDue: false,
            gradePoints: 12,
            score: '1.0',
            classAvgScore: 1,
            timeSpent: 'PT27M21S',
            classAvgTimeSpent: 'PT22M9.5S',
            totalQuestionsAnswered: 12
        },
        {
            assignmentId: 4597502,
            assignmentName: 'Physiological Adaptation EAQ ',
            assignmentType: 'MASTERY',
            gradeType: 'PASS_FAIL',
            status: 'COMPLETED',
            dueDate: '2024-07-21T03:59:00Z',
            pastDue: false,
            gradePoints: 1,
            score: '1.0',
            classAvgScore: 1,
            timeSpent: 'PT0S',
            classAvgTimeSpent: 'PT8M43S',
            totalQuestionsAnswered: 0
        },
        {
            assignmentId: 4597500,
            assignmentName: 'Pharmacological & Parenteral Therapies EAQ ',
            assignmentType: 'MASTERY',
            gradeType: 'PASS_FAIL',
            status: 'COMPLETED',
            dueDate: '2024-07-21T03:59:00Z',
            pastDue: false,
            gradePoints: 1,
            score: '1.0',
            classAvgScore: 0.019375,
            timeSpent: 'PT11H8M24S',
            classAvgTimeSpent: 'PT3H14M11.4375S',
            totalQuestionsAnswered: 123
        },
        {
            assignmentId: 4597498,
            assignmentName: 'Psychosocial Integrity EAQ ',
            assignmentType: 'MASTERY',
            gradeType: 'PASS_FAIL',
            status: 'COMPLETED',
            dueDate: '2024-07-14T03:59:00Z',
            pastDue: false,
            gradePoints: 1,
            score: '1.0',
            classAvgScore: 0.02375,
            timeSpent: 'PT4H45M39S',
            classAvgTimeSpent: 'PT3H22M55.125S',
            totalQuestionsAnswered: 146
        },
        {
            assignmentId: 4597499,
            assignmentName: 'Coagulation Modifier Drugs Pharm EAQ ',
            assignmentType: 'STANDARD',
            gradeType: 'PASS_FAIL',
            status: 'COMPLETED',
            dueDate: '2024-07-14T03:59:00Z',
            pastDue: false,
            gradePoints: 5,
            score: '1.0',
            classAvgScore: 1,
            timeSpent: 'PT1M50S',
            classAvgTimeSpent: 'PT2M1.3125S',
            totalQuestionsAnswered: 5
        },
        {
            assignmentId: 4597496,
            assignmentName: 'Antiviral and Antiretroviral Therapy',
            assignmentType: 'LESSONS',
            gradeType: 'PASS_FAIL',
            status: 'COMPLETED',
            dueDate: '2024-07-07T03:59:00Z',
            pastDue: false,
            gradePoints: 100,
            score: '1.0',
            classAvgScore: 0.9375,
            timeSpent: 'PT13M36S',
            classAvgTimeSpent: 'PT3M50.9375S',
            totalQuestionsAnswered: 18
        },
        {
            assignmentId: 4597515,
            assignmentName: 'Care of Patients with Dysrhythmias',
            assignmentType: 'SHERPATH_CASE_STUDY',
            gradeType: 'NOT_GRADED',
            status: 'NOT_STARTED',
            dueDate: null,
            pastDue: false,
            gradePoints: 100,
            score: 'null',
            classAvgScore: 0,
            timeSpent: 'PT0S',
            classAvgTimeSpent: 'PT0S',
            totalQuestionsAnswered: 0
        }
    ]
};
